import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAnalyticsStore } from "@/common/store/analyticsStore";
import { metricsBus } from "@/common/buses";
import { FeedTypeEnum } from "@/common/api";

interface IVisitedFeed {
  name: FeedTypeEnum;
  path: string;
}

export const useTrackFeedNavigation = () => {
  const feedName = useAnalyticsStore((state) => state.feedName);
  const { pathname } = useLocation();

  const isTracking = useRef(true);
  const events = useRef<IVisitedFeed[]>([]);

  useEffect(() => {
    if (!isTracking.current) {
      return;
    }

    if (feedName === null) {
      return;
    }

    if (events.current.length < 2) {
      events.current.push({ name: feedName, path: pathname });
    }

    if (events.current.length === 2) {
      const [src, dest] = events.current;

      if (src.name === dest.name && src.path === dest.path) {
        events.current = [dest];
        return;
      }

      metricsBus.emit("feedSwitched", { src: src.name, dest: dest.name });

      isTracking.current = false;
    }
  }, [feedName, pathname]);
};
